import React from "react";

interface EventData {
  summary: string;
  description: string;
  start: {
    dateTime: string;
    timeZone: string;
  };
  end: {
    dateTime: string;
    timeZone: string;
  };
  location: string;
}

export const addToGoogleCalendar = (event: EventData) => {
  const handleAddToCalendar = () => {
    window.gapi.load("client:auth2", initClient);
  };

  const initClient = () => {
    window.gapi.client
      .init({
        clientId: "AIzaSyCLlY-cgIr-c82s3wCQSG1y-XyRz7mOFyQ",
        scope: "https://www.googleapis.com/auth/calendar.events",
      })
      .then(() => {
        window.gapi.auth2.getAuthInstance().signIn().then(handleAuthResult);
      });
  };

  const handleAuthResult = () => {
    const request = window.gapi.client.calendar.events.insert({
      calendarId: "primary",
      resource: event,
    });

    request.execute((event: any) => {
      console.log("Event created:", event.htmlLink);
    });
  };

  const script = document.createElement("script");
  script.src = "https://apis.google.com/js/api.js";
  script.onload = () => {
    window.gapi.load("client", () => {
      handleAddToCalendar();
    });
  };
  document.body.appendChild(script);
};
